import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectToken } from "../../auth/authSelectors";
import applicationApi from "../../api/admin/application";
import styles from "./ApplicationForm.module.css";

export default function ApplicationForm() {
  const token = useSelector(selectToken);
  const [admissionNo, setAdmissionNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleDownload = async (e) => {
    e.preventDefault();
    if (!admissionNo.trim()) return;

    // Reset UI State
    setLoading(true);
    setErrorMessage("");

    try {
      const result = await applicationApi.downloadAdmissionPdf(
        token,
        admissionNo.trim()
      );

      // Handle failure case
      if (result.status === "error") {
        setErrorMessage(result.message || "Failed to locate student records.");
        setLoading(false); // Show button again so they can retry
        return;
      }

      // Handle success case: Download PDF
      const blob = new Blob([result.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Admission_${admissionNo}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setLoading(false); // Return to button state
    } catch (err) {
      setErrorMessage("Network error: Unable to connect to the server.");
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.appCard}>
        <div className={styles.cardHeader}>
          <h2>Student Administration</h2>
          <p>Generate and download official admission certificates</p>
        </div>

        <form onSubmit={handleDownload} className={styles.formBody}>
          <div className={styles.inputSection}>
            <label>Admission Number</label>
            <input
              type="text"
              className={styles.mainInput}
              value={admissionNo}
              onChange={(e) => setAdmissionNo(e.target.value.toUpperCase())}
              placeholder="e.g. ADM-2024-001"
              required
            />
          </div>

          <div className={styles.actionSection}>
            {loading ? (
              <div className={styles.loaderContainer}>
                <div className={styles.spinner}></div>
                <span>Processing Request...</span>
              </div>
            ) : (
              <button type="submit" className={styles.downloadBtn}>
                Download PDF
              </button>
            )}
          </div>
        </form>

        {/* Dynamic Error Feedback Section */}
        {errorMessage && (
          <div className={styles.errorBanner}>
            <div className={styles.errorIcon}>!</div>
            <div className={styles.errorText}>
              <strong>Download Failed</strong>
              <p>{errorMessage}</p>
            </div>
            <button 
              className={styles.closeBtn} 
              onClick={() => setErrorMessage("")}
            >
              &times;
            </button>
          </div>
        )}
      </div>
    </div>
  );
}